import { ListChildComponentProps } from 'react-window';
import ListSubheader from '../ListSubheader';
import Typography from '../Typography';

const AutocompleteRenderRow = (props: ListChildComponentProps) => {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top as number,
    overflow: 'scroll-y',
  };

  if ('group' in dataSet) {
    return (
      <ListSubheader key={dataSet.key} component="div" style={inlineStyle}>
        {dataSet.group}
      </ListSubheader>
    );
  }

  const [itemProps, text] = dataSet;

  return (
    <Typography component="li" {...itemProps} noWrap style={inlineStyle}>
      {text}
    </Typography>
  );
};

export default AutocompleteRenderRow;
